export const WEBSITE_BUILDER_SECTION_BACKGROUND_MEDIA_CLASS_NAME = "website-builder-section-background-media";
export const WEBSITE_BUILDER_SECTION_BACKGROUND_DARKEN_CLASS_NAME = "website-builder-section-background-darken";
export const WEBSITE_BUILDER_SECTION_PARALLAX_CLASS_NAME = "website-builder-section-parallax";
export const WEBSITE_BUILDER_SECTION_PARALLAX_MEDIA_CLASS_NAME = "website-builder-section-parallax-media";

export function websiteBuilderApplyBackgroundVideoMotion(video: HTMLVideoElement, reduceMotion: boolean) {
  if (reduceMotion) {
    video.removeAttribute("autoplay");
    video.pause();
    return;
  }

  video.setAttribute("autoplay", "");
  void video.play().catch((): void => undefined);
}

export function websiteBuilderSyncBackgroundVideoMotion(root: ParentNode, reduceMotion: boolean) {
  const videos = root.querySelectorAll(`video.${WEBSITE_BUILDER_SECTION_BACKGROUND_MEDIA_CLASS_NAME}`);

  for (let i = 0; i < videos.length; i++) {
    const video = videos[i];

    if (!(video instanceof HTMLVideoElement)) {
      continue;
    }

    websiteBuilderApplyBackgroundVideoMotion(video, reduceMotion);
  }
}
